module.exports = __webpack_public_path__ + "заключение-ФГБНУ.pdf";